<template>
    <div class="inside_page_content" style="padding-bottom: 150px; padding-top: 20px;">
        <div class="special-form-text-before">
            <p>
                Чем больше информации вы сможете предоставить сейчас, тем быстрее мы сможем решить вопрос при обмене,
                возврате.
            </p>
        </div>
        <form id="garanty-form" class="special-form" action="/personal/return/add-form-ajax.php" method="POST">
            <input type="hidden" name="ID_IN_BASKET" value="<?= $idInBasket ?>">
            <div class="special-form__row">
                <div class="special-form__label">
                </div>
                <div class="special-form__value">
                    <img v-if="currentItem.IMG" :src="currentItem.IMG" class="special-form__product-img"
                         alt="">
                    <div class="special-form__product-name">
                        {{currentItem.NAME}}
                    </div>
                </div>
            </div>
            <div class="special-form__row">
                <div class="special-form__label">
                    Код заказа: {{currentItem.ORDER_ID}}
                </div>
            </div>
            <text-area-input name="PREVIEW_TEXT" v-model="preview" label="Причина возврата"></text-area-input>
            <text-area-input name="DETAIL_TEXT" v-model="detail" label="Описание неисправности"></text-area-input>
            <file-input label="Фото гарантийных наклеек" name="G_PHOTO[]" v-model="gPhoto"></file-input>
            <file-input label="Фото неисправности" name="B_PHOTO[]" v-model="bPhoto"></file-input>
            <select-input label="Способ зачета" name="SET_OF_VARIANT" v-model="setOfVariant"
                          :options="SET_OF_VARIANT_VARIANTS"></select-input>
            <btn title="Отправить" @click="submit" type="submit"></btn>
            <btn title="Отмена" @click="cancel" type="button"></btn>
        </form>
        <div class="spec-form-success-info" style="display:none;">
            <div class="spec-form-success-info__text special-form-text-before" id="block_spec-form-success-info">
                Номер вашей заявки <span id="order-number" class="spec-form-success__number">344334</span>
                <p>
                    <a class="reclamation-link" target="_blank" href="/personal/return/pdf.php?garantOrderId=">Документ
                        рекламации</a> — распечатайте и отправьте его вместе с товаром. Так мы быстрее обработаем товар,
                    при получении. Либо приложите к товару лист с номером заявки.
                </p>
                <p>
                    Обратите внимание! <br>
                    Посылки без вложения документа рекламации или номера рекламации не обрабатываются.
                </p>
                <p>
                    Отслеживайте статус заявки в <a href="/personal/return/history.php">истории обращений</a>. <br>
                    Там же укажите номер трека посылки, когда отправите товар нам.
                </p>
                <p class="bit_info">
                    Обратите внимание! Посылки без вложения документа рекламации или номера рекламации не
                    обрабатываются.
                </p>
            </div>
        </div>
        <div class="special-form__row" style="margin-top: 30px;">
            <p class="special-form-req-address">
                ИП Рогачева Ксения Алексеевна<br>
                т. 8 383-383-09-90<br>
                630091, г. Новосибирск, ул. Титова, 1<br>
                ИНН: 540436853197
            </p>
            <p style="font-size: 20px;">
              Адрес для отправки товара:
            </p>
            <p>
              Посылки отправляются до пункта выдачи (ПВЗ)<br>
              СДЭК - ПВЗ ул. Серафимовича, 8<br>
              Почта России - 630087 г. Новосибирск ул. Геодезическая, 23<br>
            </p>

            <p>
                <br>
            </p>
            <p>
                Документ рекламации — распечатайте и отправьте его вместе с товаром. Так мы быстрее обработаем товар,
                при получении. Либо приложите к товару лист с номером заявки.
            </p>
            <p>
                Обратите внимание! Посылки без вложения документа рекламации или номера рекламации не обрабатываются.
            </p>
            <br>
        </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import FileInput from '../../form/FileInput'
  import TextAreaInput from '../../form/TextAreaInput'
  import SelectInput from '../../form/SelectInput'
  import Btn from '../../form/Btn'

  export default {
    name: 'return-request',
    components: {Btn, SelectInput, TextAreaInput, FileInput},
    computed: {
      ...mapGetters('return', [
        'orders',
        'currentItem',
        'PREVIEW_TEXT',
        'DETAIL_TEXT',
        'G_PHOTO',
        'B_PHOTO',
        'SET_OF_VARIANT_VARIANTS'
      ]),
      preview: {
        set (value) {
          this.$store.commit('return/setPreviewText', {previewText: value})
        },
        get () {
          return this.PREVIEW_TEXT
        }
      },
      detail: {
        set (value) {
          this.$store.commit('return/setDetailText', {detailText: value})
        },
        get () {
          return this.DETAIL_TEXT
        }
      },
      gPhoto: {
        set (value) {
          this.$store.commit('return/setGPhoto', {gPhoto: value})
        },
        get () {
          return this.G_PHOTO
        }
      },
      bPhoto: {
        set (value) {
          this.$store.commit('return/setBPhoto', {bPhoto: value})
        },
        get () {
          return this.B_PHOTO
        }
      },
      setOfVariant: {
        set (value) {
          this.$store.commit('return/setSetOfVariant', {setOfVariant: value})
        },
        get () {
          return this.SET_OF_VARIANT
        }
      }
    },
    methods: {
      submit ($event) {
        $event.preventDefault()
        this.$store.dispatch('return/create')
      },
      cancel () {
        this.$store.commit('return/setCurrentItem', {currentItem: null})
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Personal/Return/ReturnRequest.vue